const Unauthorized = () => {
  return (
    <div className="flex flex-col justify-center overflow-hidden sm:py-12">
      <div className="h-full w-full flex flex-col justify-center items-center">
        <center>
          <div className="overflow-auto h-full pt-20 sm:pt-56">
            <div className="relative">
              <h1 className="text-9xl font-extrabold text-gray-600 tracking-widest">403</h1>
              <div className="bg-blue-400 text-gray-100 px-2 text-sm rounded rotate-12 absolute top-14 right-28 sm:right-60">Pagina no autorizada</div>
            </div>
            <div className="text-xl text-gray-500 mt-4 p-2">
              <p className="text-center md:text-justify indent-8">No cuentas con los permisos necesarios para accessar a la pagina</p>
              <p className="text-center mt-2">Contacta con tu administrador de TI</p>
            </div>
            <a className="grid place-items-center bg-slate-800 mt-5 border-2 bg-black-light text-white w-32 h-12 rounded-md hover:bg-blue-400 shadow-md" href={'/dashboard'}>Regresar</a>
          </div>
        </center>
      </div>
    </div>
  )
}

export default Unauthorized